import createRoute            from '@widesk-ui/tools/createRoute';
import TimedNotificationModel from '@models/website/TimedNotificationModel';

const route = createRoute.dashboardFromModel(
	TimedNotificationModel,
	'TimedNotificationDashboard',
	{
		pathPrefix: '/website_entertainments/:websiteEntertainmentId',
	},
);
export default route;
